module.exports = __webpack_public_path__ + "img/Matthew Winston Sr. and Jr. in front of legacy mural.4fb11152.jpg";